<template>
  <div v-if="modelValue" class="modal-overlay" @click.self="closeModal">
    <!-- Modal Content -->
    <div
      class="modal-content"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      tabindex="-1"
      ref="modal"
    >

      <div class="modal-header">
        <h2 id="modal-title">PDF Viewer</h2>
        <button @click="closeModal" class="close-button" aria-label="Close">&times;</button>
      </div>

      <div class="modal-body">
        <PdfEmbedViewer :pdfUrl="pdfUrl" />
      </div>

      <div class="modal-footer" v-if="transactionStatus != 'Cancel'">
        <button 
        @click="downloadPDF" 
        class="download-button" 
        :disabled="downloadDisabled"
        >
          <v-badge v-if="pdfDownloadCount > 0" inline color="white" overlap :content="pdfDownloadCount" left /> 
          <v-icon left color="white">mdi-download</v-icon> 
          Download PDF
          <span v-if="downloadDisabled"> ({{ countdown }}s)</span>
        </button>
        

        <!-- <button v-else
          @click="downloadPDF" 
          class="download-button" 
          :disabled="downloadDisabled"
        >
          <v-icon left color="white">mdi-download</v-icon> 
          Download PDF
          <span v-if="downloadDisabled"> ({{ countdown }}s)</span>
        </button> -->
        

        <button 
        @click="handlePrintPDF" 
        class="print-button" 
        :disabled="loading"
        >
            <v-badge v-if="pdfPrintCount > 0" inline color="white" overlap :content="pdfPrintCount" left /> 
            <v-icon left color="white">mdi-printer</v-icon> 
            <span v-if="loading">Loading...</span>
            <span v-else>Print PDF</span>
          </button>
        

        <!-- <button v-else 
        @click="handlePrintPDF" 
        class="print-button" 
        :disabled="loading">
          <v-icon left color="white">mdi-printer</v-icon> 
          <span v-if="loading">Loading...</span>
          <span v-else>Print PDF</span>
        </button> -->
        
        
      </div>
      

    </div>
  </div>
</template>

<script>
import PdfEmbedViewer from './pdf-embed-viewer.vue';
import "firebase/auth";
import { mapState } from "vuex";

export default {
  name: 'PdfModal',
  components: {
    PdfEmbedViewer,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    pdfUrl: {
      type: String,
      required: true,
    },
    docID: {
      type: String,
      required: true,
    },
    pdfDownloadCount:{
      type: Number,
      required: true
    },
    pdfPrintCount:{
      type: Number,
      required: true
    },
    transactionStatus: {
      type: String,
     // required: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      downloadDisabled: false,
      countdown: 5,
      localPdfDownloadCount: this.pdfDownloadCount,
      localPdfPrintCount: this.pdfPrintCount,
      timer: null,
      loading: false,

    };
  },
  methods: {
    closeModal() {
      this.$emit('update:modelValue', false);
      console.log(this.modelValue)
      document.body.style.overflow = 'auto'; // Restore background scrolling
      this.resetDownloadTimer();
    },
    async downloadPDF() {
      this.downloadDisabled = true;
      this.countdown = 5;
      this.timer = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--;
        } else {
          this.downloadDisabled = false;
          clearInterval(this.timer);
        }
      }, 1000);

      const newDownloadCount = this.pdfDownloadCount + 1;
      const data = { "pdfCount": newDownloadCount ,  "docID": this.docID , "type": 'download'};

     //console.table(data)
     await this.updateDocument(data);

     this.localPdfDownloadCount = newDownloadCount;
     this.$emit('update:pdfDownloadCount', newDownloadCount);

      const link = document.createElement('a');
      link.href = this.pdfUrl;
      link.download = "netsuite-thaismartTax-" + new Date().getTime() + ".pdf";
      link.click();
    },
    async handlePrintPDF() {
      this.loading = true; 
      try {
        await this.printPDF(); 
      } catch (error) {
        console.error('Error in printPDF:', error);
      } finally {
        this.loading = false; 
      }
    },
    async printPDF() {
      return new Promise((resolve, reject) => {
        try {
          // Create an invisible iframe
          const iframe = document.createElement('iframe');
          iframe.style.display = 'none';
          iframe.src = this.pdfUrl;
          document.body.appendChild(iframe);

          // Event handler to clean up the iframe after printing
          const handleAfterPrint = () => {
            document.body.removeChild(iframe);
            window.removeEventListener('afterprint', handleAfterPrint);
            resolve(); // Resolve the promise after cleanup
          };

          // Add the afterprint event listener
          window.addEventListener('afterprint', handleAfterPrint);

          // Load the PDF and print it
          iframe.onload = async () => {
            try {
              const doc = iframe.contentDocument || iframe.contentWindow.document;

              if (doc) {

                const newPrintCount = this.pdfPrintCount + 1;
                const data = { printCount: newPrintCount, docID: this.docID, type: 'print' };

                await this.updateDocument(data); 

                this.localPdfPrintCount = newPrintCount;
                this.$emit('update:pdfPrintCount', newPrintCount);

                iframe.contentWindow.print();
                this.loading = false; 
              }
            } catch (error) {
              console.error('Error printing PDF:', error);
              reject(error); 
            }
          };
        } catch (error) {
          console.error('Error initiating print:', error);
          reject(error); 
        }
      });
    },

    handleKeyDown(event) {
      if (event.key === 'Escape' && this.modelValue) {
        this.closeModal();
      }
      if (event.key === 'Tab' && this.modelValue) {
        const focusableElements = this.$refs.modal.querySelectorAll('button');
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            event.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            event.preventDefault();
          }
        }
      }
    },
    async updateDocument(data) {
      try {
        let companyId = this.$route.params.companyId;
        await this.$store.dispatch('thaismartTax/updateThaiSmartTax', {
          companyId: companyId,
          data: data 
        });
      } catch (error) {
        console.error('Failed to update document:', error);
      }
    },
    resetDownloadTimer() {
      this.downloadDisabled = false;
      this.countdown = 5;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
   
  },
  watch: {
    modelValue(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
        this.$nextTick(() => {
          if (this.$refs.modal) {
            this.$refs.modal.focus();
          }
        });
        document.addEventListener('keydown', this.handleKeyDown);
      } else {
        document.body.style.overflow = 'auto'; // Restore background scrolling
        document.removeEventListener('keydown', this.handleKeyDown);
        this.resetDownloadTimer();
      }
    },
  },

  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = 'auto'; 
   
    this.resetDownloadTimer();
  },
};
</script>

<style scoped>
:deep(.print-button .v-badge--inline .v-badge__wrapper .v-badge__badge) {
  color: blue ;
  font-weight: bolder;
}

:deep(.download-button .v-badge--inline .v-badge__wrapper .v-badge__badge) {
  color: green ;
  font-weight: bolder;
}
/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal Content */
.modal-content {
  background-color: #fff;
  width: 90%;
  max-width: 900px;
  height: 90%;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  outline: none; 
}

/* Header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
}

.close-button {
  background: none;
  border: none;
  font-size: 25px;
  cursor: pointer;
  line-height: 1;
}

/* Body */
.modal-body {
  padding: 15px;
  flex: 1;
  overflow-y: auto;
}

/* Footer */
.modal-footer {
  padding: 10px 15px;
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
  text-align: right;
}

.modal-footer button {
  padding: 8px 12px;
  margin-left: 10px;
  font-size: 14px;
  cursor: pointer;
}

.download-button {
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  margin-right: 20px;
}

.print-button {
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
}

.print-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  
}

.download-button:disabled {
  background-color: #a5d6a7;
  cursor: not-allowed;
  
}

/* Responsive Modal Content */
@media (max-width: 600px) {
  .modal-content {
    width: 95%;
    height: 95%;
  }
}
</style>
